import type { SelectOption } from "@/components/common/inputs/InputSelect";
import type { PlainObject } from "@/interfaces/common";

export function generateOptionsFromEnum(enumValue: PlainObject, { sort = true, distinct = true } = {}): SelectOption[] {
  const options = Object.entries(enumValue).reduce<SelectOption[]>((data, [value, label]) => {
    if (distinct && data.find((option) => option.value === value || option.label === label)) {
      return data;
    }

    return [...data, { value, label }];
  }, []);

  if (sort) {
    options.sort((firstOption, secondOption) => firstOption.label.localeCompare(secondOption.label));
  }

  return options;
}
